import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'redux/rootReducer'
/**
 * Direct selector to the favoris state domain
 */

const selectFavorisDomain = (state: AppState) => state.favoris

/**
 * Other specific selectors
 */

export const makeSelectFavoris = createSelector(
  selectFavorisDomain,
  (substate) => substate.favoris
)

export const makeSelectSelected = createSelector(
  selectFavorisDomain,
  (substate) => substate.selected
)

export const makeSelectStatus = createSelector(
  selectFavorisDomain,
  (substate) => substate.status
)

export const makeSelectError = createSelector(
  selectFavorisDomain,
  (substate) => substate.error
)

export const makeSelectStatusExportFile = createSelector(
  selectFavorisDomain,
  (substate) => substate.statusExportFile
)

export const makeSelectErrorExportFile = createSelector(
  selectFavorisDomain,
  (substate) => substate.errorExportFile
)

export const makeSelectExportFileBlob = createSelector(
  selectFavorisDomain,
  (substate) => substate.exportFileBlob
)

export const makeSelectDoNotShowModalSupprimerFavoris = createSelector(
  selectFavorisDomain,
  (substate) => substate.doNotShowModalSupprimerFavoris
)

export const makeSelectStatusDeleteFavoris = createSelector(
  selectFavorisDomain,
  (substate) => substate.statusDeleteFavoris
)

export const makeSelectErrorDeleteFavoris = createSelector(
  selectFavorisDomain,
  (substate) => substate.errorDeleteFavoris
)

// https://github.com/reduxjs/reselect#q-how-do-i-create-a-selector-that-takes-an-argument
export const makeSelectFavoriStatusCommentaire = (uid: string) =>
  createSelector(
    selectFavorisDomain,
    (substate) => substate.favoris[uid].statusCommentaire
  )

export const makeSelectFavoriErrorCommentaire = (uid: string) =>
  createSelector(
    selectFavorisDomain,
    (substate) => substate.favoris[uid].errorCommentaire
  )

export const makeSelectFavoriStatusUrlAnnonce = (uid: string) =>
  createSelector(
    selectFavorisDomain,
    (substate) => substate.favoris[uid].statusUrlAnnonce
  )

export const makeSelectFavoriErrorUrlAnnonce = (uid: string) =>
  createSelector(
    selectFavorisDomain,
    (substate) => substate.favoris[uid].errorUrlAnnonce
  )

/**
 * Default selector
 */

const selectFavoris = createSelector(
  selectFavorisDomain,
  (substate) => substate
)

export default selectFavoris
